import Vue from "vue"

import App from "./App.vue"
import router from "./router"
import vuetify from "./plugins/vuetify"
import store from "./store"
import VueHtmlToPaper from "vue-html-to-paper"
import VueSwal from "vue-swal"
import "viewerjs/dist/viewer.css"
import Vuer from "v-viewer"
import * as VueGoogleMaps from "vue2-google-maps"
import VueClipboard from "vue-clipboard2"
import VueLazyload from "vue-lazyload"
import VuePlaceAutocomplete from "vue-place-autocomplete"
import BackToTop from "vue-backtotop"
import VueCoreVideoPlayer from "vue-core-video-player"
import VueSignaturePad from "vue-signature-pad"

Vue.use(VueSignaturePad)

let key_ggmap
let key_arr = [
    process.env.VUE_APP_GOOGLE_MAPS_KEY_7,
    process.env.VUE_APP_GOOGLE_MAPS_KEY_8,
]
let key_arr2 = [
    process.env.VUE_APP_GOOGLE_MAPS_KEY_3,
    process.env.VUE_APP_GOOGLE_MAPS_KEY_4,
    process.env.VUE_APP_GOOGLE_MAPS_KEY_5,
]
let key_arr3 = [
    process.env.VUE_APP_GOOGLE_MAPS_KEY_6,
    process.env.VUE_APP_GOOGLE_MAPS_KEY_7,
    process.env.VUE_APP_GOOGLE_MAPS_KEY_8,
]

if (localStorage.team_name == undefined) {
    key_ggmap = key_arr[Math.floor(Math.random() * key_arr.length)]
} else {
    if (localStorage.team_name == "ONSITE") {
        if (localStorage.role_name == "WFH") {
            key_ggmap = process.env.VUE_APP_GOOGLE_MAPS_KEY_1
        } else if (
            localStorage.role_name == "TL" ||
            localStorage.role_name == "HOST"
        ) {
            key_ggmap = process.env.VUE_APP_GOOGLE_MAPS_KEY_2
        } else {
            key_ggmap = key_arr2[Math.floor(Math.random() * key_arr2.length)]
        }
    } else if (localStorage.team_name == "NONHP") {
        key_ggmap = key_arr3[Math.floor(Math.random() * key_arr3.length)]
    } else {
        key_ggmap = key_arr3[Math.floor(Math.random() * key_arr2.length)]
    }
}


// console.log(key_ggmap)

require("./assets/style/main.css")
Vue.use(VueCoreVideoPlayer)

Vue.config.productionTip = false
import { VueEditor } from "vue2-editor"
const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
}
Vue.use(VueLazyload)
Vue.use(BackToTop)
Vue.use(Vuer, {
    name: "vuer",
})
Vue.component("VueEditor", VueEditor)
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VueGoogleMaps, {
    load: {
        key: key_ggmap,
        libraries: "places",
    },
    installComponents: true,
})
Vue.use(VuePlaceAutocomplete)

Vue.use(VueHtmlToPaper, options)
Vue.use(VueSwal)

import VueQRCodeComponent from "vue-qrcode-component"
Vue.component("qr-code", VueQRCodeComponent)

import ThailandAutoComplete from "vue-thailand-address-autocomplete"
Vue.component("ThailandAutoComplete", ThailandAutoComplete)

new Vue({
    vuetify,
    render: (h) => h(App),
    store,
    router,
}).$mount("#app")
